import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { vehicleTypeGroups } from 'constants/carHire';
import LoadingOverlayLayout from 'layouts/LoadingOverlayLayout/LoadingOverlayLayout';
import CarHireOption from 'components/CarHire/CarHireOption';
import CarHireOptionsHeader from 'components/CarHire/CarHireOptionsHeader';
import { selectHireCar } from 'redux/actions/bookActions';
import * as modalActions from 'actions/modalActions';
import * as optimizelyUtil from 'utils/optimizely';

import './CarHireOptionsList.scss';

const mapStateToProps = state => ({
  carHireOptions: state.bookState.getIn(['entities', 'carHires']),
  isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
  numberOfNights: state.bookState.getIn(['data', 'num_nights']),
});

const mapDispatchToProps = dispatch => ({
  selectHireCar: carId => dispatch(selectHireCar(carId)),
  toggleModal: bindActionCreators(modalActions.toggleModal, dispatch),
});

export class CarHireOptionsList extends Component {
  static propTypes = {
    carHireOptions: ImmutablePropTypes.mapOf(
      ImmutablePropTypes.mapContains({
        vehicleType: PropTypes.string.isRequired,
        pricing: ImmutablePropTypes.mapContains({
          webPrice: PropTypes.number,
        }),
      }),
    ).isRequired,
    numberOfNights: PropTypes.number.isRequired,
    selectHireCar: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  state = {
    firstThreeOptions: [],
  };

  componentWillMount() {
    this.updateFirstThreeOptions(this.props.carHireOptions);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.carHireOptions !== this.props.carHireOptions) {
      this.updateFirstThreeOptions(newProps.carHireOptions);
    }
  }

  updateFirstThreeOptions(carHireOptions) {
    let groupsCheapest = Immutable.List();
    carHireOptions.forEach((carHireOption) => {
      const vehicleType = carHireOption.get('vehicleType');
      const groupIndex = vehicleTypeGroups.findIndex(group => group.includes(vehicleType));
      if (groupsCheapest.get(groupIndex) === undefined) {
        groupsCheapest = groupsCheapest.set(groupIndex, carHireOption);
      } else {
        const currentCheapest = groupsCheapest.getIn([groupIndex, 'pricing', 'webPrice']);
        const currentOptionPrice = carHireOption.getIn(['pricing', 'webPrice']);

        if (currentOptionPrice < currentCheapest) {
          groupsCheapest = groupsCheapest.set(groupIndex, carHireOption);
        }
      }
    });

    this.setState({
      firstThreeOptions: groupsCheapest.filter(v => v),
    });
  }

  handleSelectOption = (hireCar) => {
    const vehicleType = hireCar.get('vehicleType');
    const groupIndex = vehicleTypeGroups.findIndex(group => group.includes(vehicleType));

    optimizelyUtil.fireEvent(`OfferSummaryCarHireGroup${groupIndex + 1}`, 'clicked');
    this.props.selectHireCar(hireCar.get('id'));
  };

  render() {
    const { numberOfNights, carHireOptions } = this.props;
    const { firstThreeOptions } = this.state;

    const numberOfDays = numberOfNights + 1;

    return (
      <LoadingOverlayLayout loadingKey="loadingPaymentPlans">
        <div className="car-hire-options-list">
          <CarHireOptionsHeader firstCarHireOption={carHireOptions.first()} />
          { firstThreeOptions.map(carHireOption => (
            <div key={carHireOption.get('id')} className="car-hire-options-list__option">
              <CarHireOption
                carHireOption={carHireOption}
                numberOfDays={numberOfDays}
                onSelectClick={this.handleSelectOption}
              />
            </div>
          ))}
        </div>
      </LoadingOverlayLayout>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarHireOptionsList);



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarHireOptionsList.jsx
 **/